export enum QuarterOptionEnum {
    MOST_RECENT = 'MOST_RECENT',
    Q1 = 'Q1',
    Q2 = 'Q2',
    Q3 = 'Q3',
    Q4 = 'Q4',
}

/**
 * Carries the user's quarterly date-range selection between a parent component and the
 * MonitoringSourcePicker (facet + search) variant that renders the quarterly date-range UI.
 *
 * Stores the raw selected values (not dropdown option models) so it serializes cleanly into the
 * online-briefing preview config JSON. The picker maps these values to/from its dropdown options.
 */
export class QuarterlyDateRangeSettingsModel {
    isCalendarQuarters: boolean = true;
    selectedQuarter: QuarterOptionEnum | null = null;
    selectedYear: string | null = null;
}
